import { useContext } from 'react';
import { SelectedOrgUnitContext } from './SelectedOrgUnitProvider';

export const useSelectedOrgUnit = () => {
  const selectedOrgUnitState = useContext(SelectedOrgUnitContext);
  if (!selectedOrgUnitState) {
    throw new Error('useSelectedOrgUnit must be used within a SelectedOrgUnitProvider');
  }
  return selectedOrgUnitState;
};
